"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputState = exports.InputStateTypes = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
var InputStateTypes;
(function (InputStateTypes) {
    InputStateTypes["NUMBER"] = "number";
    InputStateTypes["PASSWORD"] = "password";
    InputStateTypes["TEXT"] = "text";
    InputStateTypes["COLOR"] = "color";
})(InputStateTypes || (exports.InputStateTypes = InputStateTypes = {}));
class InputState {
    get value() {
        return this._value;
    }
    get error() {
        return this._error;
    }
    get isAutoFocused() {
        return this._isAutoFocused;
    }
    set isAutoFocused(value) {
        this._isAutoFocused = value;
    }
    constructor(label, id = core_shared_1.IkeId.generate(), type) {
        this._type = 'inputstate';
        /** Current parsed value of the input */
        this._value = null;
        /** Current value of the input displayed to the user (may be invalid) */
        this.inputValue = null;
        /** Whether the input is currently focused */
        this.focused = false;
        /** Whether the input text is currently selected */
        this.selected = false;
        /** Whether the input has been touched */
        this.touched = false;
        /** Error message for the input */
        this._error = '';
        /** Whether the input is disabled */
        this.disabled = false;
        /** Whether the input is read-only */
        this.readOnly = false;
        /** Placeholder input text */
        this.placeholder = '';
        /** Label of the input */
        this.label = '';
        /** Type of input eg 'password' */
        this.type = undefined;
        /** Input name used for form submission. Also used by browsers for input suggestion. */
        this.name = null;
        this.isRequired = false;
        this._isAutoFocused = false;
        this.isLabelShown = true;
        /*isErrorShown is used to disable the standard error message display (at generic input level) in order to display it later im the code (usefull for composite input field, like Location which is made of 3 NumberInputField)*/
        this.isErrorShown = true;
        this.reactions = [];
        this.id = id || core_shared_1.IkeId.generate();
        this.label = label;
        this.type = type;
    }
    setValue(val) {
        this._value = val;
        this.inputValue = this.formatInputValue(val);
    }
    setInputValue(val) {
        this.inputValue = val;
        this._value = this.parseInputValue(val);
    }
    formatInputValue(val) {
        return val != null ? String(val) : null;
    }
    parseInputValue(val) {
        return val;
    }
    reset() {
        this._value = null;
        this.inputValue = null;
        this._error = '';
        this.focused = false;
        this.touched = false;
        this.disabled = false;
    }
    setFocused(val) {
        this.focused = val;
    }
    setTouched() {
        this.touched = true;
    }
    setSelected(selected) {
        this.selected = selected;
    }
    setError(error) {
        this._error = error || '';
    }
    setDisabled(disabled) {
        this.disabled = disabled;
    }
    setAutoFocus(value) {
        this.isAutoFocused = value;
        this.focused = value;
    }
    setPlaceholder(placeholder) {
        this.placeholder = placeholder;
    }
    hasError() {
        return this.error != null && this.error.length > 0;
    }
    get isFilled() {
        if (typeof this.value === 'string') {
            return this.value.trim().length > 0;
        }
        return this.value != null;
    }
    get isValid() {
        if (this.isRequired && !this.isFilled) {
            return false;
        }
        return !this.hasError();
    }
    reaction(expression, effect, opts) {
        this.reactions.push((0, mobx_1.reaction)(expression, effect, opts));
    }
    onValue(cb) {
        this.reaction(() => this.value, (v) => (0, mobx_1.runInAction)(() => cb(v)));
    }
    /**
     * This function is designed to be optionally over written by the input state that requires an onblur function
     */
    onBlur(_e) {
        return;
    }
    /**
     * This function is designed to be optionally over written by the input state that requires an onInput function
     */
    onInput(_e) {
        return;
    }
    destroy() {
        // Destroy any reactions
        this.reactions.map((c) => c());
    }
}
exports.InputState = InputState;
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "_value", void 0);
tslib_1.__decorate([
    mobx_1.computed
], InputState.prototype, "value", null);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "inputValue", void 0);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "focused", void 0);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "selected", void 0);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "touched", void 0);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "_error", void 0);
tslib_1.__decorate([
    mobx_1.computed
], InputState.prototype, "error", null);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "disabled", void 0);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "readOnly", void 0);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "placeholder", void 0);
tslib_1.__decorate([
    mobx_1.observable
], InputState.prototype, "isRequired", void 0);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setValue", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setInputValue", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setFocused", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setTouched", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setSelected", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setError", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setDisabled", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setAutoFocus", null);
tslib_1.__decorate([
    mobx_1.action
], InputState.prototype, "setPlaceholder", null);
tslib_1.__decorate([
    mobx_1.computed
], InputState.prototype, "isFilled", null);
tslib_1.__decorate([
    mobx_1.computed
], InputState.prototype, "isValid", null);
//# sourceMappingURL=input.state.js.map